import React  , {useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import Weather from '../../assets/images/weather-app.jpg';
import Aos from "aos";
import 'aos/dist/aos.css';

const Title = styled.div`
font-size: 40px;
display:flex;
color: #385963;
font-weight: 600;
margin-bottom: 10px;
`;

const Description = styled.div`
font-size: 20px;
margin-bottom: 20px;
color:#91abb3;
`;

const WeatherContainer = styled.div`
display:flex;
flex-direction: column;
margin-bottom: 120px;
`; 

const Image = styled.img`
height: 500px;
width: auto;
`;

const WeatherHome = () => {
  useEffect(()=>{
    Aos.init({duration:1000})
  },[]);

  const { i18n } = useTranslation();

  return (
    <WeatherContainer>
      <Title  data-aos="zoom-in-down">{i18n.t('weather')}</Title>
      <Description data-aos="fade-right">{i18n.t('weatherDescription')}</Description>
      <Image src={Weather} data-aos="fade-right" />
    </WeatherContainer>
  )
}

export default WeatherHome
